module.exports = __webpack_public_path__ + "static/media/purplePic.88eae196.jpg";